import type { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';

type PT = DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> & {
  listLength: number;
  skeletonItem: (i: number) => ReactNode;
};

export const Skeleton = ({ listLength, skeletonItem, ...props }: PT) => {
  const arr = new Array(listLength);
  return skeletonItem ? (
    <section {...props}>{[...arr].map((_, index) => skeletonItem(index))}</section>
  ) : undefined;
};
